import angular from 'angular';

import TeamRadioComponent from './team-radio.cmpt';

export default angular
    .module('application.component.team-radio', [])
    .component(TeamRadioComponent.selector, TeamRadioComponent);



// WEBPACK FOOTER //
// ./src/application/component/team-radio/index.js